export const checklist_theme = {
  openMenuTheme: 'Open themamenu',
  confirmNotApplicationText:
    'Indien het thema niet van toepassing is, zullen de waarden verloren gaan. Wilt u bevestigen  ?',
  confirmNotApplicationTitle: 'Bevestig dat het thema niet van toepassing is',
};
